<template>
  <div
    class="f-column mh-0 w-100"
    style="gap: 1rem; max-height: 100%"
  >
    <TableBody
      ref="tablebody"
      :items
      :isInfinite="false"
      size="small"
      class="mh-0"
      style="
        min-height: 0;
        --overflow-y-head: scroll;
        --overflow-y-body-scroller: scroll;
        --min-height-table: clamp(1px, 42rem, 70vh);
        --max-height-table: 70vh;
        --container-no-data-position: relative;
      "
      :data-tst="`${tstPrefix}_table`"
    >
      <template #head_before>
        <TableHead
          :thead
          :hasSpacer="false"
          class="large-scroll-track"
        >
        </TableHead>
      </template>
      <template #default="{ item, index }">
        <IcmCalculatorResultTableRow
          :item
          :thead
          :index
          :tstPrefix="`row_${index}`"
          v-bind="$attrs"
        >
        </IcmCalculatorResultTableRow>
      </template>
    </TableBody>
  </div>
</template>

<script>
import TableHead from '@/components/DataTables/v2/TableHead'
import TableBody from '@/components/DataTables/v2/TableBody'
import IcmCalculatorResultTableRow from '@/components/DataTables/v2/tables/IcmCalculatorResultTable/IcmCalculatorResultTableRow'

export default {
  name: 'IcmCalculatorResultTable',
  components: {
    TableHead,
    TableBody,
    IcmCalculatorResultTableRow,
  },
  props: {
    items: { type: Array, default: () => [] },
    tstPrefix: { type: String, default: 'icm_calc_result' },
  },
  computed: {
    thead() {
      return {
        stack: {
          name: this.$t('table_head.stack'),
        },
        chip_percentage: {
          name: this.$t('table_head.chip_percentage'),
        },
        ev: {
          name: this.$t('table_head.ev_dollar'),
        },
        ev_percentage: {
          name: this.$t('table_head.ev_percentage'),
        },
      }
    },
  },
}
</script>
